import React from 'react';
//styles
import 'bootstrap/dist/css/bootstrap.css';
import './subcategory.styl';

import LogoBanners from '../../components/logo-banners/logo-banners';

class SubCategory extends React.Component {

  render(){
    return(
      <div className='subcategory-list'>
        {
          this.props.subcategories.map((subcategory)=>{
            return (
              <div className='subcategory' key={subcategory.key}>
                { subcategory.subtitle &&
                  <h2 className='subcategory-title'>{subcategory.subtitle}</h2>
                }
                { subcategory.text &&
                  <p dangerouslySetInnerHTML={{ __html: subcategory.text }} className='subcategory-text'></p>
                }
                { subcategory.text_2 &&
                  <p dangerouslySetInnerHTML={{ __html: subcategory.text_2 }} className='subcategory-text'></p>
                }
                { subcategory.text_3 &&
                  <p dangerouslySetInnerHTML={{ __html: subcategory.text_3 }} className='subcategory-text'></p>
                }
                { subcategory.text_4 &&
                  <p dangerouslySetInnerHTML={{ __html: subcategory.text_4 }} className='subcategory-text'></p>
                }
                { subcategory.linkAddress &&
                  <a className='doc-link' href={subcategory.linkAddress} target={ subcategory.linkTarget ? subcategory.linkTarget : '_parent' }>{subcategory.linkText}</a>
                }
                { subcategory.bulletItems &&
                  <ul>
                    { subcategory.bulletItems.map(item => <li key={ item.text } dangerouslySetInnerHTML={{ __html: item.text }} />) }
                  </ul>
                }
                { subcategory.logoBanners &&
                  <LogoBanners data={subcategory.logoBanners} />
                }
              </div>
            )
          })
        }
      </div>
    );
  }
}

export default SubCategory;



// WEBPACK FOOTER //
// ./src/containers/categorycontainer/SubCategory.js